// Module-level token provider: AuthProvider registers its `getToken` here on
// mount, and SPA fetches read from it. This avoids threading getToken through
// every callsite that hits an authenticated endpoint.
//
// In basic-auth mode the session lives in an HTTP-only cookie, so getToken()
// returns the sentinel `'basic'` and we send no Authorization header — the
// browser attaches the cookie automatically. In Supabase mode getToken()
// returns the JWT and we send `Authorization: Bearer <jwt>`.

type TokenProvider = () => Promise<string | null>;

let provider: TokenProvider | null = null;

export function setAuthTokenProvider(p: TokenProvider | null): void {
  provider = p;
}

export async function authHeaders(): Promise<Record<string, string>> {
  if (!provider) return {};
  const token = await provider();
  if (!token || token === 'basic') return {};
  return { Authorization: `Bearer ${token}` };
}
